import {
  TABLE_GRID_HEADER_HEIGHT,
  TABLE_ROW_MEASURE_HEIGHT,
} from '@/features/shared/components/tableSystem/tableConstants';
import { s, typographyTokens } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

export const tableSx: SxProps<Theme> = {
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator': {
    color: 'divider',
    display: 'flex !important',
    opacity: '1 !important',
    visibility: 'visible !important',
    pointerEvents: 'auto !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator--sideRight': {
    display: 'flex !important',
    opacity: '1 !important',
    visibility: 'visible !important',
    pointerEvents: 'auto !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator--sideLeft': {
    display: 'flex !important',
    opacity: '1 !important',
    visibility: 'visible !important',
    pointerEvents: 'auto !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-iconSeparator': {
    color: 'divider',
    display: 'block !important',
    opacity: '1 !important',
    visibility: 'visible !important',
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnSeparator svg': {
    display: 'block !important',
    opacity: '1 !important',
    visibility: 'visible !important',
  },
  '& .MuiDataGrid-columnsManagementHeader': {
    display: 'none !important',
  },
  '& .MuiDataGrid-columnsManagementFooter': {
    display: 'none !important',
  },
  '& .MuiDataGrid-paper': {
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    boxShadow: 'none',
    overflow: 'hidden',
  },
  '& .MuiDataGrid-panelWrapper': {
    p: 0,
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-panelContent': {
    p: 0,
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-columnsManagement': {
    p: 0,
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-columnsManagementRow': {
    margin: 0,
    px: s('sm'),
    py: s('xs'),
    minHeight: 44,
    borderRadius: 0,
  },
  '& .MuiDataGrid-columnsManagementRow .MuiFormControlLabel-label': {
    fontSize: '15px',
  },
  '& .MuiDataGrid-menuList, & .MuiDataGrid-menuList .MuiMenuItem-root': {
    backgroundColor: 'background.paper',
  },
  '& .MuiDataGrid-menuList .MuiMenuItem-root': {
    minHeight: 40,
    px: s('sm'),
    py: s('xs'),
  },
  '& .MuiDataGrid-menuList .MuiMenuItem-root.Mui-selected': {
    backgroundColor: 'action.hover',
  },
  '& .MuiDataGrid-menuList .MuiMenuItem-root.Mui-selected:hover': {
    backgroundColor: 'action.selected',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer, & .MuiDataGrid-columnHeaderTitleContainerContent': {
    borderLeft: 'none !important',
    borderRight: 'none !important',
  },
  '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader--withRightBorder, & .MuiDataGrid-columnHeader--withLeftBorder':
    {
      borderRight: 'none !important',
      borderLeft: 'none !important',
    },
  '& .MuiDataGrid-columnHeader.MuiDataGrid-withBorderColor': {
    borderRight: 'none !important',
    borderLeft: 'none !important',
  },
  '& .MuiDataGrid-columnHeaders': {
    minHeight: `${TABLE_GRID_HEADER_HEIGHT}px !important`,
    maxHeight: `${TABLE_GRID_HEADER_HEIGHT}px !important`,
    height: `${TABLE_GRID_HEADER_HEIGHT}px !important`,
    alignItems: 'center',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  '& .MuiDataGrid-columnHeader': {
    minHeight: `${TABLE_GRID_HEADER_HEIGHT}px !important`,
    maxHeight: `${TABLE_GRID_HEADER_HEIGHT}px !important`,
    height: `${TABLE_GRID_HEADER_HEIGHT}px !important`,
    alignItems: 'center',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer, & .MuiDataGrid-columnHeaderDraggableContainer, & .MuiDataGrid-columnHeaderTitleContainerContent':
    {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
  '& .MuiDataGrid-cell--withRightBorder, & .MuiDataGrid-cell--withLeftBorder': {
    borderRight: 'none !important',
    borderLeft: 'none !important',
  },
  '& .MuiDataGrid-row': {
    minHeight: `${TABLE_ROW_MEASURE_HEIGHT}px !important`,
    maxHeight: 'none !important',
    height: 'auto !important',
  },
  '& .MuiDataGrid-cell': {
    minHeight: `${TABLE_ROW_MEASURE_HEIGHT}px !important`,
    maxHeight: 'none !important',
    height: 'auto !important',
    py: s('none'),
    fontSize: '15px',
    fontWeight: typographyTokens.body.fontWeight,
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cellContent': {
    fontSize: '15px',
    fontWeight: typographyTokens.body.fontWeight,
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="name"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="latestExecutionStatus"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="latestBuildStatus"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="actions"]': {
    alignItems: 'flex-start',
  },
  '& .MuiDataGrid-cell[data-field="testLatestExecutionPassed"]': {
    alignItems: 'flex-start',
  },
  '&.MuiDataGrid-loading .suite-latest-pie': {
    visibility: 'hidden',
  },
  '&& .MuiDataGrid-row, && .MuiDataGrid-row .MuiDataGrid-cell': {
    backgroundColor: 'transparent !important',
  },
  '&& .MuiDataGrid-row:hover, && .MuiDataGrid-row.Mui-hovered': {
    backgroundColor: 'transparent !important',
  },
  '&& .MuiDataGrid-row:hover .MuiDataGrid-cell, && .MuiDataGrid-row.Mui-hovered .MuiDataGrid-cell':
    {
      backgroundColor: 'transparent !important',
    },
  '&& .MuiDataGrid-row.Mui-selected, && .MuiDataGrid-row.Mui-selected:hover': {
    backgroundColor: 'transparent !important',
  },
  '&& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell, && .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell':
    {
      backgroundColor: 'transparent !important',
    },
};
